import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DsLinkModule } from '@bmw-ds/components';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-view-data-renderer',
  standalone: true,
  imports: [CommonModule, DsLinkModule],
  template: `
    <span class="vin-cell">
      <ds-link
        *ngIf="showLink"
        href="#"
        [label]="label"
        [tone]="tone"
        (click)="onClick($event)"
      ></ds-link>
      <span *ngIf="!showLink">{{ label }}</span>
    </span>
  `,
  styles: [
    `
      :host {
        display: inline-block;
      }
      .vin-cell {
        display: inline-flex;
        align-items: center;
        gap: 6px;
      }
    `,
  ],
})
export class ViewDataRendererComponent implements ICellRendererAngularComp {
  params: any;
  label: string = 'View';
  tone: string = 'action';
  showLink: boolean = true;

  agInit(params: any): void {
    this.params = params;
    this.label = String(params?.value ?? 'View');
    this.tone = this.computeTone(params);
    this.showLink = !this.isZeroValue(params?.value);
  }

  refresh(params: any): boolean {
    this.params = params;
    this.label = String(params?.value ?? 'View');
    this.tone = this.computeTone(params);
    this.showLink = !this.isZeroValue(params?.value);
    return true;
  }

  onClick(event: Event): void {
    event.preventDefault();
    if (this.params?.onClick) {
      this.params.onClick(this.params);
    }
  }

  private computeTone(params: any): string {
    const color = String(params?.data?.Color ?? '')
      .trim()
      .toLowerCase();
    const isRed = color === 'red';
    const field = String(params?.colDef?.field ?? '');
    // Only make the link red for specific fields that need red styling
    const redLinkFields = new Set(['BulletinNumber']);
    return isRed && redLinkFields.has(field) ? 'critical' : 'action';
  }

  private isZeroValue(value: any): boolean {
    if (value === 0) return true;
    if (value === '0') return true;
    if (value === null || value === undefined || value === '') return false;
    const num = Number(value);
    return !Number.isNaN(num) && num === 0;
  }
}
